import { alert, Dialog } from '@weareredlight/design-system'
import { useTranslation } from 'react-i18next'

import api from 'api/api'

type CancelTreatmentProceduresProps = {
  treatmentId: string
  procedureId: string | null
  onClose: (procedure: string | null) => void
  refreshData: () => void
}

const CancelTreatmentProcedures = ({
  treatmentId,
  procedureId,
  onClose,
  refreshData,
}: CancelTreatmentProceduresProps) => {
  const { t } = useTranslation()

  const handleCancelProcedure = async () => {
    if (procedureId) {
      await api.cancelTreatmentProcedure(treatmentId, procedureId)
      refreshData()
      alert.success(`${t('Success')}!`, t('Procedure has been cancelled.'), {
        position: 'bottom-right',
      })
    }
  }

  return (
    <Dialog
      open={!!procedureId}
      onConfirm={handleCancelProcedure}
      closeFn={() => onClose(null)}
      title={t('Confirm the procedure cancellation')}
      description={t('This will cancel the procedure.')}
      variant="danger"
      confirmButtonText={t('Confirm')}
      cancelButtonText={t('Cancel')}
    />
  )
}

export default CancelTreatmentProcedures
